import { render, staticRenderFns } from "./riskInfo.vue?vue&type=template&id=e6f2a982&scoped=true&"
import script from "./riskInfo.vue?vue&type=script&lang=js&"
export * from "./riskInfo.vue?vue&type=script&lang=js&"
import style0 from "./riskInfo.vue?vue&type=style&index=0&id=e6f2a982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f2a982",
  null
  
)

export default component.exports